import _merge from 'lodash/merge';
import { RENDERING_CONTEXT } from '@bedrock-rdk/constants';
import { Lightning } from '@lightningjs/sdk';
import { EMPTY_BLOCK_STYLE, getBlockStyle } from '../../../../block/block.style';
import { CONTENT_GAP } from '../../../../row/row.style';
import SkeletonRectangle from '../../../../skeleton/skeleton.rectangle.component';
import { getContentSizeByContentTemplateId } from '../../../content';
import { List } from '../list.component';
import { defaultContext, getInitialStyle } from './list.skeleton.style';

// NOTE: any non empty title results in the very same offsets, as only its presence matters for a block layout
const TITLE_PLACEHOLDER = 'mock';

export class ListSkeleton extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Title: {
          type: SkeletonRectangle,
        },
        Items: {},
      },
      getInitialStyle(),
    );
  }

  static getHeight({ screenSize, itemTemplate, blockIndex, isSearchPage, entry }) {
    const title = entry && entry.hideTitle ? null : { long: TITLE_PLACEHOLDER };
    const { top, bottom } = List.getOffsetsByBlockData({ screenSize, data: { title }, blockIndex });
    const { h } = getContentSizeByContentTemplateId(
      itemTemplate,
      isSearchPage ? RENDERING_CONTEXT.SEARCH : RENDERING_CONTEXT.GENERAL,
    );

    return h + top + bottom;
  }

  _construct() {
    this._style = defaultContext;
  }

  set items(value) {
    if (value) {
      const { blockIndex, itemSize, count, entry } = value;

      const blockStyle = Number.isFinite(blockIndex)
        ? getBlockStyle({
            hasTitle: !entry.hideTitle,
            isFirstBlock: blockIndex === 0,
            screenSize: this._style.screenSize,
          })
        : EMPTY_BLOCK_STYLE;

      this.patch({
        Title: {
          ...blockStyle.title,
          visible: !entry.hideTitle,
        },
        Items: {
          ...blockStyle.items,
          children: [...Array(count)].map((_, i) => ({
            type: SkeletonRectangle,
            ...itemSize,
            x: i * (itemSize.w + CONTENT_GAP[this._style.screenSize]),
          })),
        },
      });
    } else {
      this.tag('Items').children = [];
    }
  }
}
